module.exports = {
  email: 'reachfelixgan@gmail.com',

  socialMedia: [
    {
      name: 'Linkedin',
      url: 'https://www.linkedin.com/in/thefelixgan/',
    },
    // {
    //   name: 'Wechat',
    //   url: 'thefelixgan',
    // },
    {
      name: 'Substack',
      url: 'https://felixgan.substack.com/',
    },
    // {
    //   name: 'Instagram',
    //   url: 'https://www.instagram.com/_casual_penguin/',
    // },
  ],

  navLinks: [
    {
      name: 'Home',
      url: '/',
    },
    {
      name: 'Blog',
      url: '/blog',
    },
    {
      name: 'Research',
      url: '/research',
    },
  ],

  colors: {
    green: '#64ffda',
    navy: '#0a192f',
    darkNavy: '#020c1b',
  },

  srConfig: (delay = 200, viewFactor = 0.25) => ({
    origin: 'bottom',
    distance: '20px',
    duration: 500,
    delay,
    rotate: { x: 0, y: 0, z: 0 },
    opacity: 0,
    scale: 1,
    easing: 'cubic-bezier(0.645, 0.045, 0.355, 1)',
    mobile: true,
    reset: false,
    useDelay: 'always',
    viewFactor,
    viewOffset: { top: 0, right: 0, bottom: 0, left: 0 },
  }),
};
